// TODO: Test with filters
// TODO: Animate in content (optional)
class InfiniteScroll {
  constructor({
    container = '#product-grid',
    pagination = '#product-pagination',
    offset = 0,
    callback = null,
  } = {}) {
    this.settings = { container, pagination, offset }
    this.container = document.querySelector(container)
    this.pagination = document.querySelector(pagination)
    this.callback = callback

    this.observer = new IntersectionObserver(this.observe.bind(this), {
      rootMargin: `0px 0px ${offset}px 0px`,
    })

    this.observer.observe(this.pagination)
  }

  observe(entries, observer) {
    const entry = entries[0]

    if (entry.isIntersecting) {
      this.loadMore()

      observer.disconnect()
    }
  }

  async loadMore() {
    const result = await this.callback(this.settings)

    if (!result) {
      this.end()
    } else {
      this.observer.observe(this.pagination)
    }
  }
  
  end() {
    this.pagination.remove()
    this.observer.disconnect()
  }

  destroy() {
    this.observer.disconnect()
  }
}

class ShopifyInfiniteScroll extends InfiniteScroll {
  constructor({
    container = '#product-grid',
    pagination = '#product-pagination',
    offset = 0,
    callback = null,
    transformCallback = null,
    buttonId = '#disable-infinite-scroll'
  } = {}) {
    super({ container, pagination, offset, callback, transformCallback })

    this.transformCallback = transformCallback
    this.button = document.querySelector(buttonId);

    if (this.button) {
      this.button.addEventListener('click', this.disableScroll.bind(this));
    } else {
      console.error('Button element not found. Make sure to specify the correct button ID.');
    }
    
    if (window.location.href.includes('?page=') || window.location.href.includes('&page=')) {
      this.disableScroll()
      this.accessiblityLinks()
    }

  }

  async loadMore() {
    const paginationLink = this.pagination.querySelector('a')

    if (!paginationLink) {
      console.error('No pagination link found')
      return
    }

    const paginationUrl = paginationLink.href

    let response = await fetch(paginationUrl)

    if (this.transformCallback && typeof this.transformCallback === 'function') {
      response = this.transformCallback(response)
    }

    const markup = await response.text()

    const parser = new DOMParser()
    const newPage = parser.parseFromString(markup, 'text/html')

    const newContainer = newPage.querySelector(this.settings.container)
    const newPagination = newPage.querySelector(this.settings.pagination)
    this.container.insertAdjacentHTML('beforeend', newContainer.innerHTML)

    // Adds a class to the product card that is focused in order for accessibility
    const cards = document.querySelectorAll('.card');

    cards.forEach((card) => {
      card.addEventListener('focusin', () => {
        card.classList.add('card--focused');
      });

      card.addEventListener('focusout', () => {
        card.classList.remove('card--focused');
      });
    });

    if (this.callback && typeof this.callback === 'function') {
      // TODO: Add basic variables (current page etc.) to pass to callback
      this.callback(response)
    }

    if (typeof newPagination === 'undefined') {
      this.end()
    } else {
      this.pagination.innerHTML = newPagination.innerHTML
      this.observer.observe(this.pagination)
    }
  }

  disableScroll() {
    this.destroy()
    this.container.classList.add('grid--infinite-scroll-disabled')
  }

  accessiblityLinks() {
    const mainLink = document.querySelector('#skip-to-content')
    const collectionLinkHTML = '<a class="skip-to-content-link" href="#product-grid">Skip to products</a>'
    const journalLinkHTML = '<a class="skip-to-content-link" href="#journal__grid">Skip to articles</a>'
    
    if (window.location.href.includes('/collections/') || window.location.href.includes('/search')) {
      mainLink.insertAdjacentHTML('beforebegin', collectionLinkHTML)
    } else if (window.location.href.includes('/blogs/')) {
      mainLink.insertAdjacentHTML('beforebegin', journalLinkHTML)
    }
  }
}